(function($) {

	var JdaAutocomplete = function ($elem, options) {

		var pluginName = 'jdaAutocomplete';

		/*##################################################################
		// Init
		##################################################################*/

		var scope = this;

		this.$elem = $elem;

		this.dataUrl = null;
		this.data = null;

		this.settings = $.extend({
			// These are the defaults.
			wrapClass: '',
			data: null,
			dataUrl: null,
			isIeFunc: null
		}, options);

		/*##################################################################
		// Event listeners
		##################################################################*/

		this.addEventListeners = function() {
			var ieVer = scope.settings.isIeFunc();
			var isIeWithScrollBug = ieVer && ieVer < 11;
			var timeout;
			var localClose = function() {
				setTimeout(function() {
					scope.removeOldListHtml();
				}, 250);
			};
			$elem.on('keypress', function() {
				if (timeout) clearTimeout(timeout);
				var val = $(this).val();
				timeout = setTimeout(function() {
					var matches = scope.getMatches(val);
					scope.updateAutocompleteHtml(matches);
				}, 150);
			});
			$elem.blur(function(e) {
				// return;
				if (isIeWithScrollBug) {
					e.preventDefault();
					return;
				}
				localClose();
			});
			$elem.parent().on('click', '.suggestions > li', function() {
				var val = $(this).text();
				$(this).closest('.jda-autocomplete').find('input').val(val);
				scope.removeOldListHtml();
			});
			if (isIeWithScrollBug) {
				$(document).on('click', function(e) {
					var $target = $(e.target);
					if (!$target.is($elem)) {
						localClose();
					}
				});
			}
		};

		/*##################################################################
		// Methods
		##################################################################*/

		this.isIe = function() {
			return scope.settings.isIeFunc();
		},

		this.init = function() {
			this.discernData(function(data) {
				scope.data = data;
				scope.modifyHtml();
				scope.addEventListeners();
			});
		};

		this.modifyHtml = function() {
			var classes = ['jda-autocomplete'];
			var style = scope.$elem.data('style');
			if (style) classes[classes.length] = 'jda-autocomplete-style-' + style;
			$elem.addClass('jda-autocomplete-input');
			scope.$elem.wrap('<div class="'+classes.join(' ')+'"></div>');
		};

		this.getMatches = function(val) {
			return scope.data.filter(function(thisVal) {
				var thisValLc = thisVal.toLowerCase();
				var valLc = val.toLowerCase();
				return valLc.length > 1 && thisValLc.indexOf(valLc) > -1;
			});
		};

		this.updateAutocompleteHtml = function (matches) {
		    var matchResultMarkup = matches.map(function (match) { return '<li>' + match + '</li>'; }).join('');
		    var newListHtml = '<div class="matches-wrap"><ul class="suggestions">' + matchResultMarkup + '</ul></div>';
			scope.removeOldListHtml();
			if (matches.length) {
				scope.$elem.parent().append(newListHtml);
				scope.$elem.trigger(pluginName + '.dropdownShown', {
					$rootElem: scope.$elem.parent()
				});
			}
		};

		this.removeOldListHtml = function() {
			scope.$elem.parent().parent().find('.matches-wrap').remove();
		};

		this.discernDataUrl = function() {
			var dataUrl = $elem.data('url');
			if (!dataUrl) {
				dataUrl = scope.settings.dataUrl;
			}
			scope.dataUrl = dataUrl;
		};

		this.discernData = function(callback) {
			if (!(scope.data || scope.dataUrl)) {
				scope.discernDataUrl();
			}
			scope.data = scope.getData(scope.dataUrl, callback);
		};

		this.getData = function(url, callback) {
			if (scope.data) {
				callback.call(null, scope.data);
				return;
			}
			$.ajax({
				url: url,
				dataType: 'json',
				success: function(data) {
					callback.call(this, data);
				}
			});
		};

		this.init();
		return this;
	};

	$.fn.jdaAutocomplete = function (options) {
		return this.each(function () {
			(new JdaAutocomplete($(this), options));
		});
	};

}(jQuery));
